import React, { FC } from "react";

export interface PageLoaderProps {
  className?: string;
}

const Loader: FC<PageLoaderProps> = ({ className = "" }) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className="w-8 h-8 border-3 border-primary-500 border-t-transparent rounded-full animate-spin"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
};

export default Loader;
